import { ActionTypeList } from '../../constants'

const initialState = {
    loading: false,
    error: "",
    targetSetting: {
        name: '',
        targetId: '',
        description: '',
        url: '',
        loginFormElements: [],
        customHeaders: [],
        customCookies: []
    },
};

const currentTargetSettingPayload = (state = initialState, action) => {
    //console.log(`currentTargetDetailPayload state ${JSON.stringify(state)} action ${JSON.stringify(action)}`);

    switch (action.type) {
        case ActionTypeList.TARGET_SETTING_DETAIL_FETCHED:
            return {
                loading: false,
                targetSetting: action.payload,
                error: ""
            };
        case ActionTypeList.TARGET_SETTING_FETCH_DETAIL:
            return {
                loading: true,
                targetSetting: {},
                error: action.payload
            };
        case ActionTypeList.TARGET_SETTING_NEW_FLAG_TOGGLED:
            return {
                loading: false,
                targetSetting: {},
                error: action.payload
            };
        case ActionTypeList.TARGET_SETTING_FIELD_UPDATED:
            const payload = action.payload;

            return {
                loading: false,
                targetSetting: { ...state.targetSetting, [payload.fieldName]: payload.fieldValue },
                error: ""
            };
        default:
            return state;
    }
}

export default currentTargetSettingPayload;